import React, { ReactElement, ReactNode, createContext } from "react"

import { LCTOnlyDatasets } from "../../../../../../constants/enums"
import { AppError } from "../../../../../../errors/errorProcessors"
import { IDeviceFormContextValue } from "../../../../types/providerTypes"
import AmendHpDeviceProvider from "../../../hp/providers/baseProviders/amendHpDeviceProvider"
import { HpDeviceFormData } from "../../../types/providerTypes"

export const AmendEbDeviceContext = createContext(
    {} as IDeviceFormContextValue<HpDeviceFormData>
)

type AmendEbDeviceProviderProps = {
    formData: HpDeviceFormData
    setFormData: React.Dispatch<React.SetStateAction<HpDeviceFormData>>
    formDataIsLoading: boolean
    systemReference: string
    formDataError?: AppError
    attachmentUUID?: string
    children: ReactNode
}

/**
 * Thin wrapper around AmendHpDeviceProvider — delegates all logic,
 * only overrides the dataset (EB) and context.
 */
const AmendEbDeviceProvider = ({
    formData,
    setFormData,
    formDataIsLoading,
    formDataError,
    systemReference,
    attachmentUUID,
    children,
}: AmendEbDeviceProviderProps): ReactElement => (
    <AmendHpDeviceProvider
        formData={formData}
        setFormData={setFormData}
        formDataIsLoading={formDataIsLoading}
        formDataError={formDataError}
        systemReference={systemReference}
        attachmentUUID={attachmentUUID}
        dataset={LCTOnlyDatasets.EB}
        deviceContext={AmendEbDeviceContext}
    >
        {children}
    </AmendHpDeviceProvider>
)

AmendEbDeviceProvider.defaultProps = {
    formDataError: undefined,
    attachmentUUID: undefined,
}

export default AmendEbDeviceProvider
